<template>
  <div style="padding: 5px;">
    <datepicker style="margin-bottom: 3px;" placeholder="Von" v-model="dateFilter.gte" :language="de" :bootstrap-styling="true" />
    <datepicker style="margin-bottom: 3px;" placeholder="Bis" v-model="dateFilter.lte" :language="de" :bootstrap-styling="true" />
    <b-btn class="btn btn-sm btn-block" @click="search"> Anwenden </b-btn>
    <b-btn class="btn btn-sm btn-block" @click="deleteFilter"> Filter zurücksetzen </b-btn>
  </div>
</template>

<script>
import filterMixins from './filter-mixins'
import Datepicker from 'vuejs-datepicker'
import { de } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'date-filter',
  mixins: [filterMixins],
  components: {
    Datepicker
  },
  data () {
    return {
      dateFilter: {},
      de: de
    }
  },
  methods: {
    search () {
      console.log(this.dateFilter, typeof this.dateFilter.gte)
      this.$set(this.query.freeTextFilters, this.field, this.dateFilter)
      this.query.offset = 0
      this.$set(this.query, 'nChanges', this.query.nChanges + 1)
    },
    setOptions () {
      var setFilter = this.query.freeTextFilters[this.field]
      this.dateFilter = setFilter || {}
    }
  },
  watch: {
    'query.freeTextFilters': {
      handler () {
        this.dateFilter = this.query.freeTextFilters[this.field] || {}
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/plugins/dateFilter.vue